module.exports = __webpack_public_path__ + "static/media/(000106).791a90b4.jpg";